import Checkbox from '@mui/material/Checkbox';
import Paper from '@mui/material/Paper';
import TableSortLabel from '@mui/material/TableSortLabel';
import Tooltip from '@mui/material/Tooltip';
import PropTypes from 'prop-types';
import React from 'react';

class QListHeader extends React.Component {
  createSortHandler = (property) => (event) => {
    this.props.onRequestSort(event, property);
  };

  render() {
    const { columnData, onSelectAllClick, order, orderBy, numSelected, rowCount, disableDelete } = this.props;

    let first = true;
    return (
      <Paper elevation={0}>
        <div style={{ display: 'flex' }}>
          {!disableDelete && (
            <div style={{ minWidth: 45, flex: 0, paddingLeft: 0 }}>
              <Checkbox
                color='primary'
                inputProps={{ 'aria-label': 'Select All', id: 'checkbox-select-all' }}
                style={{ height: '30px', fontSize: '21px', paddingLeft: 0 }}
                indeterminate={numSelected > 0 && numSelected < rowCount}
                checked={numSelected === rowCount}
                onChange={onSelectAllClick}
              />
            </div>
          )}
          {/* eslint-disable no-return-assign */}
          {columnData.map(
            (column) => (
              <Paper
                key={column.id}
                elevation={0}
                style={{
                  flex: column.flex,
                  fontSize: '14px',
                  marginTop: 'auto',
                  marginBottom: 'auto',
                  textAlign: 'left',
                }}
              >
                <Tooltip title='Sort' placement={column.numeric ? 'bottom-end' : 'bottom-start'} enterDelay={300}>
                  <TableSortLabel
                    style={{ color: '#676767', paddingLeft: first ? 0 : 0 }}
                    active={orderBy === column.id}
                    direction={order}
                    onClick={this.createSortHandler(column.id)}
                    id={`sort-by-${column.id}`}
                  >
                    {column.label}
                  </TableSortLabel>
                </Tooltip>
                {(first = false)}
              </Paper>
            ),
            this,
          )}
          <div style={{ flex: 0, minWidth: 25 }} />
        </div>
      </Paper>
    );
  }
}

QListHeader.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.string.isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
  columnData: PropTypes.array.isRequired,
  disableDelete: PropTypes.bool,
};

export default QListHeader;
